import { Box, Container } from '@mui/material';
import imagen from "../../assets/Membership/Banner.png";
import HeroMembresia from "./hero";
import BrandBnfo from "./brandBeneficios";
import BrandProfesionales from "./brandProfesionales";
import BrandEmpresas from "./brandEmpresas";
import BrandPlanes from "./brandPlanes";
import BrandMembresia from "./membresia";
import BrandSolicita from "./solicita";
import {ScrollMove, ScrollStatic} from "../../components/common/ScrollItem";
import { dataCatalogoMembresiaSalud, inscripcionMembresiaSalud} from "../../data/data";
import BotonDescarga from "./botonDescarga";

const salud365 = () => {
  return (
    <Container className="centeredContainer"
      sx={{
        mt: "90px",
        paddingLeft: "0 !important",
        paddingRight: "0 !important",
        maxWidth: "none !important",
      }}
    >
      
      <Box
        sx={{
          width: {xs: "80%", md:"50%"},
          position: "relative",
          overflow: "hidden",
          height: "100%",
        }}
      >
        <ScrollStatic>
          <Box
            component="img"
            src={imagen}
            alt="image"
            loading="lazy"
            sx={{
              width: "100%",
              objectFit: "contain",
            }}
          />
        </ScrollStatic>
      </Box>
      
      <ScrollMove>
        <HeroMembresia />
      </ScrollMove>

      <ScrollMove>
        <BrandBnfo />
      </ScrollMove>

      <ScrollMove>
      {dataCatalogoMembresiaSalud.map((item, index) => (
        <BotonDescarga
          key={index}
          title={item.titulo}
          description={item.subtitulo}
          buttonText={item.boton}
          background={"#EBF4FF"}
          onButtonClick={item.pdf}
        />
      ))}
      </ScrollMove>

      <ScrollMove>
        <BrandProfesionales />
      </ScrollMove>

      {/* <ScrollMove>
        <BrandEmpresas />
      </ScrollMove> */}

      <ScrollMove>
        <BrandPlanes />
      </ScrollMove>

      <ScrollMove>
        {inscripcionMembresiaSalud.map((item, index) => (
          <BotonDescarga
            key={index}
            title={item.titulo}
            description={item.subtitulo}
            buttonText={item.boton}
            background={"#E3F0FF"}
            onButtonClick={item.pdf}
          />
        ))}
      </ScrollMove>

      <ScrollMove>
        <BrandMembresia />
      </ScrollMove>

      <ScrollStatic>
        <BrandSolicita />
      </ScrollStatic>

    </Container>
  );
};

export default salud365;